import axios from '@/plugins/axios.js';

export function list(params) {
    return axios.get("mp/user/list", { params: params });
}

export function bindCompany(params) {
    return axios.post("mp/user/bindCompany", params);
}

export function unbindCompany(params) {
    return axios.post("mp/user/unbindCompany", params);
}